import { useContext } from 'react';

import { DuplicateContext } from './context';

const useDuplicate = ({ api, pageUrl, labelKey }) => {
  const {
    setApi, setPageUrl, setLabelKey, handleDuplicateCheck,
  } = useContext(DuplicateContext);

  setApi(api);
  setLabelKey(labelKey);
  setPageUrl(pageUrl || `${api}s`);

  return { handleDuplicateCheck };
};

export default useDuplicate;
